module.exports = __webpack_public_path__ + "static/media/more-all-products-5.49d3b10a.png";